import "./App.css";
import Footer from "./components/footer";
import Header from "./components/header";
import Home from "./components/home";
import Cart from "./components/cart";
import Wishlist from "./components/wishlist";
import MyProfile from "./components/myProfile";
import ProductDescriptionPage from "./components/productDescriptionPage";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ApolloProvider } from "@apollo/client";
import client from "./ApolloClient";
import { HeadProvider } from "react-head";
import { ToastProvider } from "./components/toast/index.jsx";
import AllProducts from "./components/allProducts/index.jsx";
import HelpAndSupport from "./components/helpAndSupport/index.jsx";
import OrderHistory from "./components/myOrders/index.jsx";
import Pages from "./components/footer/Pages.jsx";
import LoginModalContext from "./contexts/LoginModalContext";
import { useState, useCallback } from "react";

function App() {
  const [loginOpen, setLoginOpen] = useState(false);
  const openLogin = useCallback(() => setLoginOpen(true), []);
  const closeLogin = useCallback(() => setLoginOpen(false), []);

  return (
    <ApolloProvider client={client}>
      <HeadProvider>
        <ToastProvider>
        <LoginModalContext.Provider value={{ openLogin }}>
          <Router>
            <div className="flex flex-col min-h-screen">
              <Header loginModalOpen={loginOpen} onCloseLoginModal={closeLogin} />
              <div className="flex-grow">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/cart" element={<Cart />} />
                  <Route path="/wishlist" element={<Wishlist />} />
                  <Route path="/profile" element={<MyProfile />} />
                  <Route path="/latest" element={<AllProducts />} />
                  <Route path="/all-products" element={<AllProducts />} />
                  <Route path="/shop-by-category" element={<AllProducts />} />
                  <Route
                    path="/product/:productId"
                    element={<ProductDescriptionPage />}
                  />
                  <Route path="/order-history" element={<OrderHistory />} />
                  <Route path="/coming-soon" element={<HelpAndSupport />} />
                  <Route path="/shipping_return_policy" element={<Pages />} />
                  <Route path="/terms_conditions" element={<Pages />} />
                  <Route path="/privacy_policy" element={<Pages />} />
                  <Route path="/track_order" element={<Pages />} />
                  <Route path="/return_policy" element={<Pages />} />
                  <Route path="/cancellation_policy" element={<Pages />} />
                  <Route path="/terms-and-privacy" element={<Pages />} />
                </Routes>
              </div>
              <Footer />
            </div>
          </Router>
        </LoginModalContext.Provider>
        </ToastProvider>
      </HeadProvider>
    </ApolloProvider>
  );
}

export default App;
